
import JSEncrypt from 'jsencrypt'
import CryptoJS from 'crypto-js'



const pub = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCcKm65GSwvIZ7u3eT8IsbRvWK6\r\n"
                    + "WG2SHmODcKfZ+a2dki1fs5R1dq2EyePibBti5f7TwlZGN263ih9QNx9vNk8Qdmcv\r\n"
                    + "NVW+mxqCRsiXsDb2W2Jcbv36Y3f4baGvbzCHIhi4EKuPj6ps0+c9x03RI96MGqXU\r\n"
                    + "aPZyoRr/m04EisKUiwIDAQAB"
const priv = "MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAJwqbrkZLC8hnu7d\r\n"
                    + "5PwixtG9YrpYbZIeY4Nwp9n5rZ2SLV+zlHV2rYTJ4+JsG2Ll/tPCVkY3breKH1A3\r\n"
                    + "H282TxB2Zy81Vb6bGoJGyJewNvZbYlxu/fpjd/htoa9vMIciGLgQq4+PqmzT5z3H\r\n"
                    + "TdEj3owapdRo9nKhGv+bTgSKwpSLAgMBAAECgYBAuS1utcokNpECeyDehyNT5mQ2\r\n"
                    + "y1OOTd38qgJHSz3zopP/qBQNowRDltFGFHw9PwmghljvfSX8F9jmjBIRK7cUe+C2\r\n"
                    + "r1KCk2czZTGqd5NFVLN6I+J+tFnTF2+34Evlr1+n8BbuphPS0nWAUYp8Iqm576/2\r\n"
                    + "qZLCBCGlUmd9MPr7MQJBAMjIp88jmZ5996wMXnCo1rod0zStxB72/T4qnl+cP1Il\r\n"
                    + "XPxD0E/igzNa8zpE200FU5nU/F3rzdsXq8uHsEmcFC8CQQDHHKESh2dDggfu9x0h\r\n"
                    + "pJWEa3jQySp/T3fFaHu7aq3VqxeGMZWefzznNo4BN84mQ6kGB1q7zV3aF1601KPV\r\n"
                    + "jcJlAkBLcWHkahsBu5FBW1BtAnPUcPp4M8aaX/Hd1wO1Jy9/vTxIKW7vZUwpEsaL\r\n"
                    + "oW3JbfPwvF+rJrwt06IgkraBohzPAkEAhGi3fJjqxOvt1q4ig0Lt4zeNClsclbkF\r\n"
                    + "DxQiZEnW/CZg6G6E7vfySlfvK0QvJScNeeLeJdG2PdgYtOxLXzJ8OQJAYH/LvmjH\r\n"
                    + "DcrWRt0I+XU6u/uzSH/lX5Ebnlq7x4oKLkYoWGXS+wC/lqAcrhXdjkiMYfjp05Ao\r\n"
                    + "ObhJd5kzGbRvSw=="
// aes生成秘钥偏移 
// const iv = CryptoJS.enc.Latin1.parse('0123456789ABCDEF')

const iv = CryptoJS.enc.Utf8.parse('0123456789ABCDEF') // 十六位十六进制数作为密钥偏移量

function getAesKey(num) {
	let library = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	let key = "";
	for (var i = 0; i < num; i++) {
		let randomPoz = Math.floor(Math.random() * library.length);
		key += library.substring(randomPoz, randomPoz + 1);
	}

	return key

}

//aes解密方法
function aesDecrypt(word, key) {

	
	let decrypt = CryptoJS.AES.decrypt(word, CryptoJS.enc.Utf8.parse(key), { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
	let decString = CryptoJS.enc.Utf8.stringify(decrypt).toString()
	if (decString.charAt(0) === '{' || decString.charAt(0) === '[') {
	        // JSON.parse
	  decString = JSON.parse(decString)
	}
	return decString
	

}
//aes加密方法
function aesEncrypt(word, key) {
	
		
	if (word instanceof Object) {
	        // JSON.stringify
	  word = JSON.stringify(word)
	}
	let encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(word), CryptoJS.enc.Utf8.parse(key), { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
	return encrypted.toString()

}

//rsa加密
function EncryptNode(data) {
	var en = new JSEncrypt()
	en.setPublicKey(pub)
	let encrypted = en.encrypt(data)
	return encrypted
}
//rsa解密
function DecryptNode(data) {
	var decrypt = new JSEncrypt()
	decrypt.setPrivateKey(priv)
	let dncrypted = decrypt.decrypt(data)
	return dncrypted
}


// function EncryptNode(data) {
// 	let pubKey = forge.pki.publicKeyFromPem(pub)
// 	return base64_encode(pubKey.encrypt(forge.util.encodeUtf8(data), 'RSAES-OAEP', {
// 		md: forge.md.sha256.create(),
// 		mgf: forge.mgf.mgf1.create(forge.md.sha1.create())
// 	}))
// }

// function DecryptNode(data) {
// 	let privateKey = forge.pki.privateKeyFromPem(priv)
// 	return forge.util.decodeUtf8(privateKey.decrypt(atob(data), 'RSAES-OAEP', {
// 		md: forge.md.sha256.create(),
// 		mgf: forge.mgf.mgf1.create(forge.md.sha1.create())
// 	}))
// }

export{
	getAesKey,
	aesDecrypt,
	aesEncrypt,
	DecryptNode,
	EncryptNode
}
